import React, { useEffect, useState } from 'react';
import logo from '../images/yo_logo.png';

const AppBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [storeLink, setStoreLink] = useState('');

    useEffect(() => {
        // Check if user has already dismissed the banner
        const dismissed = localStorage.getItem('yolomeal.banner_dismissed');
        if (dismissed) {
            return;
        }

        // Detect if device is mobile
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        // Check for Android first
        if (/android/i.test(userAgent)) {
            // TODO: Replace with Real Google Play Store Link
            setStoreLink('https://play.google.com/store/apps/details?id=com.app.yolomeal');
            setIsVisible(true);
        }
        // Check for iOS
        else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            // TODO: Replace with Real Apple App Store Link
            setStoreLink('https://apps.apple.com/us/app/yolomeal/id6752503390');
            setIsVisible(true);
        }

        // For local testing on desktop without changing user agent:
        // setIsVisible(true);
        // setStoreLink('https://play.google.com/store/apps/details?id=com.yolomeal.app');
    }, []);

    if (!isVisible) return null;

    const handleClose = () => {
        localStorage.setItem('yolomeal.banner_dismissed', 'true');
        setIsVisible(false);
    };

    return (
        <div className="app-banner">
            <button className="app-banner-close" onClick={handleClose} aria-label="Close banner">
                &times;
            </button>
            <img src={logo} alt="YoloMeal Logo" className="app-banner-logo" />
            <div className="app-banner-content">
                <h4 className="app-banner-title">YoloMeal App</h4>
                <p className="app-banner-desc">Get the best experience.</p>
            </div>
            <a href={storeLink} target="_blank" rel="noopener noreferrer" className="app-banner-button">
                Open
            </a>
        </div>
    );
};

export default AppBanner;
